<!-- 创建时间2024/04/29 15:55:52 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：欢迎语 -->
<template>
  <div class="is-content">
    {{ content }}
    <div v-if="subContent" class="mt8 color-gray-8" :class="fullscreen ? 'standard-size-16' : 'standard-size-14'">{{ subContent }}</div>
    <template v-if="showInstruct">
      <div class="yxtbiz-flex-center color-gray-9 mt12" :class="fullscreen ? 'standard-size-16' : 'standard-size-14'">
        <div class="flex-1 ellipsis">{{ $t('pc_biz_ai_promot_tips') }}</div>
        <div v-if="list.length > 3" class="yxtbiz-flex-center hand" @click="change">
          <yxtf-svg class="icon-copy" width="16px" height="16px" icon-class="turn-right" />
          <span class="ml6">{{ $t('pc_biz_ai_change_promot'/** 换一换 */) }}</span>
        </div>
      </div>
      <div class="yxtbiz-ai-robot__welcome-enter mt8">
        <div v-for="item in randomList" :key="item.id" class="yxtbiz-ai-robot__welcome-enter-item" :class="fullscreen ? 'is-item-horizontal' : ''" @click="handle(item)">
          <div :class="fullscreen ? 'standard-size-16' : 'standard-size-14'">{{ item.appName }}</div>
          <div v-if="item.guide" class="ellipsis-2 mt4 color-gray-8" :class="fullscreen ? 'standard-size-14' : 'standard-size-12'">{{ item.guide }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { ASK_TYPE } from '../../const';
import { postTreasureList } from '../../service';
export default {
  name: 'welcomeAnswer',
  inject: ['getFullscreen', 'getClient'],
  props: {
    msg: { // 回答的消息体
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: [],
      randomList: []
    };
  },
  computed: {
    fullscreen() {
      return this.getFullscreen();
    },
    content() {
      return this.msg.contentDetail && this.msg.contentDetail.content;
    },
    subContent() {
      return this.msg.contentDetail && this.msg.contentDetail.subContent;
    },
    showInstruct() {
      return this.list.length > 0 && this.msg.askType === ASK_TYPE.INSTRUCT;
    }
  },
  watch: {
    'msg.askType': {
      immediate: true,
      handler(val) {
        if (val === ASK_TYPE.INSTRUCT) this.getTaskList();
      }
    }
  },
  methods: {
    async getTaskList() {
      const res = await postTreasureList({type: 0, clientType: this.getClient()});
      let list = [];
      res.forEach(item => {
        if (item.categoryCode !== 'kng') {
          list = list.concat(item.appBeanList || []);
        }
      });
      this.list = list;
      this.change();
      this.$nextTick(() => {
        this.$root.$emit('SCROLL_END');
      });
    },
    change() {
      const index = this.getRandomNumbers(3, this.list.length - 1);
      let randomList = [];
      if (index) {
        index.forEach(i => randomList.push(this.list[i]));
      } else {
        randomList = this.list;
      }
      this.randomList = randomList;
    },
    getRandomNumbers(count, max) {
      if (count >= max) return;
      let numbers = [];
      while (numbers.length < count) {
        let num = Math.floor(Math.random() * max) + 1;
        if (numbers.indexOf(num) === -1) numbers.push(num);
      }
      return numbers;
    },
    handle(item) {
      this.$root.$emit('TREASURE_HANDLE', {showType: 'treasure', ...item});
    }
  }
};
</script>